import LanguageButton from "../LanguageButton";
import ThemeToggle from "../ThemeToggle";
import { navigationLabels } from "../../data/portfolioContent";
import { pick } from "../../utils/localization";

const primaryPages = ["home", "about", "projects"];
const privateGroupedPages = [];
const publicGroupedPages = ["blog", "learningPath"];

const PortfolioNav = ({ activePage, canAccessPrivatePages = false, language, onPageChange }) => {
    const groupedPages = canAccessPrivatePages
        ? [...publicGroupedPages, ...privateGroupedPages]
        : publicGroupedPages;
    const activeGroupedPage = groupedPages.includes(activePage) ? activePage : "";

    return (
        <nav className="portfolio-nav">
            <div className="portfolio-nav-inner">
                <div className="portfolio-nav-main">
                    <button type="button" className="portfolio-logo" onClick={() => onPageChange("home")}>
                        <span className="portfolio-logo-mark" aria-hidden="true"></span>
                        <span className="portfolio-logo-word">
                            Tam<span>.</span>
                        </span>
                    </button>
                    <div className="portfolio-nav-links">
                        {primaryPages.map((page) => (
                            <button
                                key={page}
                                type="button"
                                className={`portfolio-nav-link${activePage === page ? " is-active" : ""}`}
                                onClick={() => onPageChange(page)}
                            >
                                {pick(navigationLabels[page], language)}
                            </button>
                        ))}

                        {groupedPages?.length > 0 ?
                            <label className={`portfolio-nav-select${activeGroupedPage ? " is-active" : ""}`}>
                                <span className="sr-only">{pick(navigationLabels.more, language)}</span>
                                <select
                                    aria-label={pick(navigationLabels.more, language)}
                                    value={activeGroupedPage}
                                    onChange={(event) => {
                                        if (event.target.value) {
                                            onPageChange(event.target.value);
                                        }
                                    }}
                                >
                                    <option value="">{pick(navigationLabels.more, language)}</option>
                                    {groupedPages.map((page) => (
                                        <option key={page} value={page}>
                                            {pick(navigationLabels[page], language)}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            : <></>
                        }
                    </div>

                    <div className="portfolio-controls">
                        <LanguageButton />
                        <ThemeToggle />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default PortfolioNav;
